import * as URI from 'urijs';

/**
 * This is set by the angular/cli option `deploy-url`.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
declare const __webpack_public_path__;

class AssetUtilsClass {
  /**
   * Return a base URI for assets, relative to the `deploy-url` or current page.
   *
   * @returns {URI} - a base URI for asset paths
   */
  getAssetBaseUri(): URI {
    return new URI(this.getDeployUrlOrEmptyPath());
  }

  /**
   * Return a base URI string for assets, relative to the `deploy-url` or current page.
   *
   * @returns {string} - a base URI string for asset paths
   */
  getDeployUrlOrEmptyPath(): string {
    return __webpack_public_path__ || '';
  }
}

export const AssetUtils = new AssetUtilsClass();
